import React from 'react'
import './Experience.css'

const Experience = () => {
  return (
    <div className="experience" id='Experience'>
        <div className="achievement">
            <div className="circle">2+</div>
            <span>years</span>
            <span>Experience</span>
        </div>
        <div className="achievement">
            <div className="circle">6+</div>
            <span>completed</span>
            <span>projects</span>
        </div>
        <div className="achievement">
            <div className="circle">3+</div>
            <span>companies</span>
            <span>Work</span>
        </div>
    </div>
  )
}

export default Experience